module.exports = __webpack_public_path__ + "img/47.172314f9.jpg";